import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { VisitorUpfrontRegistrationListComponent } from './component/visitor-upfront-registration-list.component';

@NgModule({
  declarations: [
    VisitorUpfrontRegistrationListComponent,
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonUIElementsModule,
    CommonLayoutModule,

  ],
  exports: [
    VisitorUpfrontRegistrationListComponent
  ]
})
export class VisitorUpfrontRegistrationListModule { }
